<template>
  <tx-dialog v-model="visible" :title="t('personalSettings.resetTitle')" width="450px">
    <div class="p-6">
      <p class="mb-4 text-gray-700 text-sm">
        {{ t('personalSettings.resetDescription') }}
      </p>
      <div class="flex space-x-6 mb-6">
        <tx-checkbox v-model="selected.general" :label="t('personalSettings.tabs.general')" />
        <tx-checkbox v-model="selected.merch" :label="t('personalSettings.tabs.merch')" />
        <tx-checkbox v-model="selected.whiteboard" :label="t('personalSettings.tabs.whiteboard')" />
        <tx-checkbox v-model="selected.notifications" :label="t('personalSettings.tabs.notifications')" />
      </div>
      <div class="flex justify-center space-x-4">
        <tx-button type="confirm" :text="t('personalSettings.actions.resetAndSave')" width="160px" @click="onResetAndSave" />
        <tx-button type="cancel" :text="t('personalSettings.actions.resetOnly')" width="160px" @click="onResetOnly" />
      </div>
    </div>
  </tx-dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TxDialog from '@/shared/components/TxDialog.vue'
import TxCheckbox from '@/shared/components/TxCheckbox.vue'
import TxButton from '@/shared/components/TxButton.vue'

const emit = defineEmits<{
  (e: 'reset', tabs: string[]): void
  (e: 'resetAndSave', tabs: string[]): void
}>()
const { t } = useI18n()
const visible = ref(false)

const selected = ref({
  general: true,
  merch: false,
  whiteboard: false,
  notifications: false,
})

function getSelectedTabs() {
  return Object.entries(selected.value)
    .filter(([_, isSelected]) => isSelected)
    .map(([tab]) => tab)
}

function onResetAndSave() {
  emit('resetAndSave', getSelectedTabs())
  visible.value = false
}

function onResetOnly() {
  emit('reset', getSelectedTabs())
  visible.value = false
}

function show() {
  visible.value = true
}

defineExpose({ show })
</script>
